import "./../App.css"
import { NavLink } from "react-router-dom"

const NavBar = () => {
    return (
        <div className="nav">
            <NavLink to={'/'}>Cash</NavLink>
            <NavLink to={'/user'}>Users</NavLink>
        </div>
    )
}

export default NavBar;